import confetti from "canvas-confetti";

/**
 * Perfect-Day "executive sparks" celebration.
 *
 * Differs from `celebrateRecord()` (Phase 4) on purpose — the personal-best
 * banner is indigo + cyan + bigger bursts; this is SMALLER, CYAN-ONLY and
 * feels like a precise flash of light instead of a party.
 *
 * Palette: strictly brand cyan + icy whites. NO rainbow, NO warm colours.
 * Shapes: circles only. Ticks kept low so it fades quickly and doesn't
 * linger while the user keeps interacting with logros.
 */
const SPARK_CONFIG = {
  particleCount: 40,
  startVelocity: 25,
  spread: 55,
  decay: 0.92,
  gravity: 0.6,
  scalar: 0.8,
  ticks: 120,
  shapes: ["circle"],
  colors: ["#00E5FF", "#67E8F9", "#A5F3FC", "#E0F7FA", "#BAE6FD"],
  disableForReducedMotion: true,
};

const ORIGINS = [
  { x: 0.2, y: 0.4 },
  { x: 0.8, y: 0.4 },
  { x: 0.5, y: 0.2 },
];

export function perfectDaySparks() {
  if (typeof window === "undefined") return;

  const fire = (origin) => {
    try {
      confetti({ ...SPARK_CONFIG, origin });
    } catch (e) {
      // Cosmetic — never surface.
      console.warn("perfect day sparks failed", e);
    }
  };

  ORIGINS.forEach((origin, i) => {
    setTimeout(() => fire(origin), i * 400);
  });
}
